import { useTranslation } from '@mint-lib/i18n';

import type { HeaderOption } from '../../components/molecules/MetricAutocomplete.jsx';

export const useLocalizedMetricTypesLabels = () => {
  const { t } = useTranslation('@myn/import-hub');

  const headerLabelsByType: Record<HeaderOption['headerType'], string> = {
    metric: t('METRICS'),
    dimension: t('DIMENSIONS'),
    custom_metric: t('CUSTOM METRICS'),
    noCustomMetrics: t('CUSTOM METRICS'),
  } as const;

  return headerLabelsByType;
};
